import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpBackend,
  HttpClient,
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { NotificationService } from '../../service/notification.service';
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  httpBackend: HttpClient;

  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");
  pendingRequests: any = [];
  lastWebApiId = 0;
  token = '';

  constructor(
    private handler: HttpBackend,
    private router: Router,
    private notificationService: NotificationService,
    private loaderService: LoaderService
  ) {
    this.httpBackend = new HttpClient(this.handler);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.status === 400) {
          if (errorResponse.error['errors']) {
            this.notificationService.openErrorSnackbarComponent(
              errorResponse.error.errors
            );
          }
        }
        // 401 > 500 Errore Generico
        else if (errorResponse.status > 401 || errorResponse.status === 0) {
          this.router.navigate(['/error-page']);
        }
        this.loaderService.hide();

        return throwError(errorResponse);
      })
    );
  }
}
